import {
    sessionUserPerms,
} from "../config";

export function checkRoutePermission(route) {
    const permissions = JSON.parse(sessionStorage.getItem(sessionUserPerms))
    if(permissions == null) { return false }
    const userPermissions = permissions.filter((elem)=>
        elem["Permission_Type"]==='Route'
        && ((elem["Permission_Target"].indexOf('\*\*') < 0 && elem["Permission_Target"]===route)
        || (elem["Permission_Target"].indexOf('\*\*') >= 0 && elem["Permission_Target"].indexOf(route.replace('/\*\*', ''))===0))
    )
    return userPermissions.length > 0
}